/** Trailing slashes break path concatenation once a baseURL is joined with `/api/...`. */
const withoutTrailingSlash = (url?: string): string => (url || '').replace(/\/+$/, '');

export const CONFIG = {
  isDevelopment: process.env.NODE_ENV === 'development',
  NODE_ENV: process.env.NODE_ENV,
  API_URL: process.env.REACT_APP_API_URL,
  AUTH_URL: process.env.REACT_APP_AUTH_URL,
  /**
   * Speaker Library service — a separate FastAPI backend. Every route wants two headers:
   * `X-API-Key` from here, and an `access-token` carrying the signed-in user's own token,
   * which `useSpeakerAxios` attaches per request.
   *
   * NOTE: the key below is compiled into the bundle and is therefore readable by anyone who
   * opens the app. Acceptable only while the Speaker service is low-risk; if it must stay
   * private it needs a backend proxy instead.
   */
  SPEAKER_URL: withoutTrailingSlash(process.env.REACT_APP_SPEAKER_LIBRARY_URL),
  SPEAKER_API_KEY: process.env.REACT_APP_SPEAKER_LIBRARY_API_KEY || '',
  /**
   * Voice Profiling Service — a third backend again, holding the voice/ML half of a speaker:
   * embeddings, the samples they were built from, and where the voice has been heard. Joined
   * to the Speaker Library on `speaker_id`.
   *
   * NOTE: it asks for no credentials at all, and at present it answers only on a LAN address
   * with no hostname. Local development only until it is published somewhere a browser on
   * staging or production can reach — every screen reading it must survive it being absent.
   */
  VOICE_PROFILING_URL: withoutTrailingSlash(process.env.REACT_APP_VOICE_PROFILING_URL),
  /**
   * MediaWhisper (WhisperX API) — a fourth backend, and the only way the panel can turn an
   * MP3 into something the Voice Profiling Service will accept: `POST /transcribe` lands the
   * audio in MinIO, and the voice service's `GET /audio/{job_id}` resolves the URL back out.
   *
   * The key is optional. `GET /jobs/{id}` declares bearer auth but answers 404 rather than
   * 401 without one, so it is sent only when configured instead of being required.
   */
  MEDIAWHISPER_URL: withoutTrailingSlash(process.env.REACT_APP_MEDIAWHISPER_URL),
  MEDIAWHISPER_API_KEY: process.env.REACT_APP_MEDIAWHISPER_API_KEY || '',
  ACCESS_TOKEN: process.env.REACT_APP_API_ACCESS_TOKEN,
  ACCESS_SECRET: process.env.REACT_APP_API_ACCESS_TOKEN_SECRET || '',
  BASENAME: process.env.PUBLIC_URL,
  DATE_ADD_HOUR: Number(process.env.REACT_APP_ADD_HOUR) || 0,
  CLIENT_URL: process.env.REACT_APP_CLIENT_URL || 'https://app-staging.media-meter.com',
  APP_VERSION: process.env.REACT_APP_APPLICATION_VERSION || 'x.x.x',
};
